import moment from 'moment-timezone';

export const getMonday = () => {
  return moment().startOf('week').add(1, 'days').format('dddd MMMM Do'); // Monday
};

export const getSunday = () => {
  return moment().endOf('week').add(1, 'days').format('dddd MMMM Do'); // Sunday
};

export const getFormatMMDDYYYY = (date) => {
  return moment(date).format('L');
};

export const isDateValid = (date) => {
  return date && moment(date).isValid();
};

export const getValidFormatMMDDYYYY = (date) => {
  return isDateValid(date) ? getFormatMMDDYYYY(date) : '-';
};

export const isFutureDate = (date, timezone) => {
  const currentTZ = timezone || DEFAULT_TIMEZONE;
  const today = moment.tz(moment(), true, currentTZ);
  return date && today && moment.tz(date, currentTZ).isAfter(today);
};

export const getFormatDateTime = (date) => moment(date).format('L LT');

export const getFormatDateTimeWithRegionalSettings = (date) =>
  moment(date)
    .tz(DEFAULT_TIMEZONE)
    .format(`${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`);
